//src/components/common/sidebar/SidebarLogo.tsx
import { Link } from "react-router-dom";

import { appConfig } from "@/config/app";

type SidebarLogoProps = {
    isCollapsed: boolean;
};

export function SidebarLogo({ isCollapsed }: SidebarLogoProps) {
    return (
        <div className="flex h-16 items-center px-6 border-b">
            <Link to="/" className="flex items-center">
                {isCollapsed ? (
                    <div className="bg-primary h-8 w-8 rounded-md flex items-center justify-center text-primary-foreground font-bold">
                        {appConfig.shortName}
                    </div>
                ) : (
                    <div className="flex items-center">
                        <div className="bg-primary h-8 w-8 rounded-md flex items-center justify-center text-primary-foreground font-bold mr-2 dark:bg-ps-blue-400">
                            {appConfig.shortName}
                        </div>
                        <h1 className="text-xl font-bold">{appConfig.name}</h1>
                    </div>
                )}
            </Link>
        </div>
    );
} 